/* eslint-disable react/prop-types */
import RemoteSelect from 'common/components/RemoteSelect/RemoteSelect';
import React from 'react';
import { useTranslation } from 'react-i18next';

const processOptions = (result) => result.map((user) => ({ value: user.id, label: user.username, user }));

const UserSelect = (props) => {
  const { t } = useTranslation();

  return (
    <RemoteSelect
      url="users"
      filters={['company', 'active']}
      isFilter={props.isFilter}
      placeholder={props.isFilter ? t('common.user') : null}
      processOptions={processOptions}
      {...props}
    />
  );
};

export default UserSelect;
